export const CREATE_PROJECT_INTERESTED_ATTEMPT = 'CREATE_PROJECT_INTERESTED_ATTEMPT';
export type CREATE_PROJECT_INTERESTED_ATTEMPT = typeof CREATE_PROJECT_INTERESTED_ATTEMPT;

export const CREATE_PROJECT_INTERESTED_SUCCESS = 'CREATE_PROJECT_INTERESTED_SUCCESS';
export type CREATE_PROJECT_INTERESTED_SUCCESS = typeof CREATE_PROJECT_INTERESTED_SUCCESS;

export const CREATE_PROJECT_INTERESTED_FAILURE = 'CREATE_PROJECT_INTERESTED_FAILURE';
export type CREATE_PROJECT_INTERESTED_FAILURE = typeof CREATE_PROJECT_INTERESTED_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/project/interested/create/Types.tsx